"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "1": "Trond Ivar Hensgaard",
  "2": "Torgeir Forseth",
  "3": "Thord Veseth Foss",
  "4": "Inge Fossland",
  "5": "Andreas Schjønhaug"
};
exports.default = _default;
module.exports = exports.default;